/**
 * List-related semantic tokens for PrimeNG preset
 * Includes list options and option groups
 */
import * as p from '../tokens/primitives.js';
import { type SemanticTokens, interactive, layout, surface, text } from '../tokens/semantic.js';

export const lists = {
  // List tokens
  list: {
    padding: p.spacing[8],
    gap: '0',
    header: {
      padding: `${layout.gap.sm} ${layout.gap.md} 0 ${layout.gap.md}`,
    },
    option: {
      padding: `${layout.gap.sm} ${layout.gap.md}`,
      borderRadius: '0',
      border: {
        radius: '0',
      },
      focus: {
        background: surface.canvas,
        color: text.primary,
      },
      selected: {
        background: interactive.primary.subtle,
        color: text.primary,
        focus: {
          background: interactive.primary.subtlePressed,
          color: text.primary,
        },
      },
      color: text.secondary,
      group: {
        background: 'transparent',
        color: text.secondary,
        font: {
          weight: p.fontWeight.semibold,
        },
        padding: `${layout.gap.sm} ${layout.gap.md}`,
      },
    },
    optionGroup: {
      padding: `${layout.gap.sm} ${layout.gap.md}`,
      fontWeight: p.fontWeight.semibold,
    },
  },
};

export function createLists(s: SemanticTokens) {
  return {
    list: {
      padding: p.spacing[8],
      gap: '0',
      header: {
        padding: `${s.layout.gap.sm} ${s.layout.gap.md} 0 ${s.layout.gap.md}`,
      },
      option: {
        padding: `${s.layout.gap.sm} ${s.layout.gap.md}`,
        borderRadius: '0',
        border: {
          radius: '0',
        },
        focus: {
          background: s.surface.canvas,
          color: s.text.primary,
        },
        selected: {
          background: s.interactive.primary.subtle,
          color: s.text.primary,
          focus: {
            background: s.interactive.primary.subtlePressed,
            color: s.text.primary,
          },
        },
        color: s.text.secondary,
        group: {
          background: 'transparent',
          color: s.text.secondary,
          font: {
            weight: p.fontWeight.semibold,
          },
          padding: `${s.layout.gap.sm} ${s.layout.gap.md}`,
        },
      },
      optionGroup: {
        padding: `${s.layout.gap.sm} ${s.layout.gap.md}`,
        fontWeight: p.fontWeight.semibold,
      },
    },
  };
}
